import React from 'react';

import trim from 'lodash/trim';

import {
  SidePage,
  Stack,
  SearchInput,
  Divider,
  VirtualizedList,
} from '@gogame/components';

import { useLoadPartners } from 'scenes/Integrations/data';

const getOptionItem = (data) => data;

export const IntegrationSelectPartner = ({
  onChange,
  onClose,
  onExited,
  open,
}) => {
  const { data = [], isLoading } = useLoadPartners();

  const [searchQuery, setSearchQuery] = React.useState('');

  const handleChangeSearchQuery = React.useCallback(
    (_e, value) => {
      setSearchQuery(trim(value));
    },
    [setSearchQuery]
  );

  const filteredData = React.useMemo(() => {
    const queryKey = searchQuery.toUpperCase();
    return searchQuery.length
      ? data.filter(({ name }) => name.toUpperCase().includes(queryKey))
      : data;
  }, [data, searchQuery]);

  const handleChangeAffiliate = React.useCallback(
    (_e, value) => {
      onChange(value);
    },
    [onChange]
  );

  return (
    <SidePage
      open={open}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading}
      size={'sm'}
    >
      <SidePage.Title title={'Select Integration’s Partner'} />
      <SidePage.NewBody disableGutters={true} dense={true} scroll={false}>
        <Stack padding={2}>
          <SearchInput
            value={searchQuery}
            onChange={handleChangeSearchQuery}
            margin={true}
          />
        </Stack>
        <Divider />
        <Stack flex={'1 0 auto'}>
          <VirtualizedList
            divider={false}
            data={filteredData}
            getOptionValue={getOptionItem}
            onItemClick={handleChangeAffiliate}
            withSearch={!!searchQuery}
          />
        </Stack>
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton label={'Cancel'} />
      </SidePage.Actions>
    </SidePage>
  );
};
